import React from 'react';

const Filter = ({ className }) => {
  return (
    <svg width="22" height="13" viewBox="0 0 22 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6.5" cy="6.5" r="5.5" stroke="white"/>
      <path d="M13 1.59971C13.7501 1.21628 14.5998 1 15.5 1C18.5376 1 21 3.46243 21 6.5C21 9.53757 18.5376 12 15.5 12C14.5998 12 13.7501 11.7837 13 11.4003" stroke="white" strokeLinecap="round"/>
      <path d="M8.37461 4.29965L3.9386 6.52284" stroke="white" strokeLinecap="round"/>
      <path d="M9.00058 6.47641L4.56458 8.6996" stroke="white" strokeLinecap="round"/>
    </svg>
  )
}

export default Filter;